import PrimaryInfoComponent from './PrimaryInformationContainer';

export default PrimaryInfoComponent;
